export const PDF_FORMAT = 'pdf';
export const JPEG_FORMAT = 'jpeg';
export const PNG_FORMAT = 'png';
export const XML_FORMAT = 'xml';
